"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./styles.scss");
var Header = function Header(_ref) {
  var displayName = _ref.displayName,
    onCancel = _ref.onCancel;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "revisions-header"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "revisions-header__title"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Change Plan for ", /*#__PURE__*/_react.default.createElement("strong", null, displayName))), /*#__PURE__*/_react.default.createElement("div", {
    className: "revisions-header__nav"
  }, onCancel && /*#__PURE__*/_react.default.createElement("button", {
    className: "btn",
    onClick: onCancel
  }, "Back to Dashboard")));
};
Header.propTypes = {
  displayName: _propTypes.default.string.isRequired,
  onCancel: _propTypes.default.func
};
var _default = Header;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-revisions-v2/dist/pf-revisions.scss');